var React = require('react');

function BandAid (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 160v192a64.05 64.05 0 0 0 64 64h96V96H64a64.05 64.05 0 0 0-64 64zm576-64h-96v320h96a64.05 64.05 0 0 0 64-64V160a64.05 64.05 0 0 0-64-64zM192 416h256V96H192zm176-232a24 24 0 1 1-24 24 23.94 23.94 0 0 1 24-24zm0 96a24 24 0 1 1-24 24 23.94 23.94 0 0 1 24-24zm-96-96a24 24 0 1 1-24 24 23.94 23.94 0 0 1 24-24zm0 96a24 24 0 1 1-24 24 23.94 23.94 0 0 1 24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 416h32V96h-32zM448 96v320h32V96z","className":"fa-primary","key":2})]);
}

BandAid.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BandAid;

BandAid.default = BandAid;
